import { CRMChannel } from "@jugl-web/rest-api";
import {
  DataLoadingWrapper,
  MultiSectionLayout,
} from "@jugl-web/ui-components";
import { useSessionStorage } from "@jugl-web/utils/hooks/useStorage";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { ChatbotPreviewBackground } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/screens/WebChatBotAccountScreen/components/ChatbotPreviewBackground";
import React from "react";
import { GenericChannelPreview } from "./components/GenericChannelPreview";
import { InstagramTile } from "./components/InstagramTile";
import { LiveChatPreview } from "./components/LiveChatPreview";
import { LiveChatTile } from "./components/LiveChatTile";
import { TwilioTile } from "./components/TwilioTile";
import { WebChatPagePreview } from "./components/WebChatPagePreview";
import { WebChatTile } from "./components/WebChatTile";
import { WhatsappTile } from "./components/WhatsappTile";

type SelectedChannel = CRMChannel | "live-chat";

export const PreviewAndInstallTabContent: React.FC<{ entityId: string }> = ({
  entityId,
}) => {
  const { isCRMConfigLoading, isCRMConfigError, refetchCRMConfig } =
    useManageAccountsDrawer();

  const [selectedChannel, setSelectedChannel] =
    useSessionStorage<SelectedChannel>(
      "cx-selected-channel",
      CRMChannel.chatbot
    );

  return (
    <DataLoadingWrapper
      isLoading={isCRMConfigLoading}
      isError={isCRMConfigError}
      onRetry={refetchCRMConfig}
    >
      <MultiSectionLayout
        leftSide={
          <div className="border-dark-200 jugl__custom-scrollbar flex h-full w-[464px] flex-col gap-7 overflow-y-auto border-0 border-r border-solid p-8">
            <WebChatTile
              isSelected={selectedChannel === CRMChannel.chatbot}
              onSelect={() => setSelectedChannel(CRMChannel.chatbot)}
            />
            <WhatsappTile
              isSelected={selectedChannel === CRMChannel.whatsapp}
              onSelect={() => setSelectedChannel(CRMChannel.whatsapp)}
            />
            <InstagramTile
              isSelected={selectedChannel === CRMChannel.instagram}
              onSelect={() => setSelectedChannel(CRMChannel.instagram)}
            />
            <TwilioTile
              isSelected={selectedChannel === CRMChannel.twilio}
              onSelect={() => setSelectedChannel(CRMChannel.twilio)}
            />
            <LiveChatTile
              isSelected={selectedChannel === "live-chat"}
              onSelect={() => setSelectedChannel("live-chat")}
            />
          </div>
        }
        className="animate-fade-in"
        classNames={{
          content: "flex items-center justify-center",
        }}
      >
        {selectedChannel === "live-chat" ? (
          <LiveChatPreview />
        ) : selectedChannel === CRMChannel.chatbot ? (
          <WebChatPagePreview entityId={entityId} />
        ) : (
          <ChatbotPreviewBackground>
            <GenericChannelPreview
              channel={selectedChannel}
              entityId={entityId}
              isPreview
            />
          </ChatbotPreviewBackground>
        )}
      </MultiSectionLayout>
    </DataLoadingWrapper>
  );
};
